<template>
  <div class="tresult-view">
    <page-header :title="headerTitle"/>
    <el-tabs v-model="activeName">
        <el-tab-pane label="Письменные" name="tresult-table"></el-tab-pane>
        <el-tab-pane label="Тесты" name="tresult-tests"></el-tab-pane>
    </el-tabs>
    <keep-alive>
        <component :readOnly="false" v-bind:is="activeName" @loaded="setDisciplineName"></component>
    </keep-alive>
  </div>
</template>

<script>
import pageHeader from '../components/pageHeader'
import TresultTests from '../components/tresultView/TresultTests'
import TresultTable from '../components/tresultView/TresultTable'
export default {
    data() {
        return {
            activeName: 'tresult-table',
            disciplineName: ''
        }
    },
    computed:{
        headerTitle(){
            return this.disciplineName
                ? `Работы студентов: ${this.disciplineName}`
                : 'Работы студентов'
        }
    },
    components:{
        'page-header': pageHeader,
        'tresult-tests':TresultTests,
        'tresult-table':TresultTable
    },
    methods:{
        setDisciplineName(name){
            if(name) this.disciplineName = name
        }
    }
}
</script>

<style lang="scss">
    .tresult-view{
        display: grid;
        grid-template-rows: min-content min-content 1fr;
        height: 100%;
        row-gap: 10px;
        .el-tabs__header{
          margin-bottom: 0;
        }
    }
</style>